<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de Periodos</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Crear periodo</strong>
            </h5>
          </div>
        </div>
        <b-form @submit="save" @reset="onReset">
          <div class="row">
            <div class="col-md-4">
              <b-form-group id="input-group-1" label="Nombre:" label-for="input-1" description="Ejemplos: 1er, primero, 1">
                <b-form-input id="input-1" v-model="form.name" required placeholder="Ingrese el nombre del periodo" trim></b-form-input>
              </b-form-group>
            </div>
            <!-- <div class="col-md-4">
              <b-form-group id="input-group-2" label="Fecha de inicio:" label-for="input-2" description="Ejemplo: 3. Si no aplica ingrese de nuevo el nombre del grado, ejemplo: Tercero">
                <b-form-input id="input-2" v-model="form.initialDate" required placeholder="Ingrese el grado en formato de número o abreviación"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-2" label="Fecha de cierre:" label-for="input-2" description="Ejemplo: 3. Si no aplica ingrese de nuevo el nombre del grado, ejemplo: Tercero">
                <b-form-input id="input-2" v-model="form.finalDate" required placeholder="Ingrese el grado en formato de número o abreviación"></b-form-input>
              </b-form-group>
            </div> -->
            <div class="col-md-4">
              <b-form-group id="input-group-2" label="Porcentaje:" label-for="input-2" description="Ejemplo: 25">
                <b-form-input id="input-2" v-model="form.percent" required placeholder="Ingrese el porcentaje sin puntos, comas ni simbolos"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-2" label="Periodo de evaluación:" label-for="input-2">
                <b-form-checkbox id="checkbox-1" v-model="form.extraPeriodEvaluation" name="checkbox-1" :value="true" :unchecked-value="false">
                  Es un examen bimestral o semestral
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>
          <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
        </b-form>
        <a-divider />
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de periodos</strong>
            </h5>
            <empty-table v-show="periodsList.length === 0"/>
            <b-table striped hover :fields="columns" :items="periodsList" head-variant="light" v-show="periodsList.length > 0" responsive>
              <!-- <template #cell(name)="level">
                {{ (level.item.student.lastName + ' ' + level.item.student.name) }}
              </template>
              <template #cell(id)="level">
                {{ level.item.student.cc }}
              </template> -->
              <template #cell(extraPeriodEvaluation)="period">
                {{ period.item.extraPeriodEvaluation ? 'Si' : 'No' }}
              </template>
              <template #cell(active)="period">
                <b-badge variant="success" v-show="period.item.active">Activado</b-badge>
                <b-badge variant="secondary" v-show="!period.item.active">Desactivado</b-badge>
              </template>
              <template #cell(percent)="period">
                {{ period.item.percent + '%' }}
              </template>
              <template #cell(finalDate)="period">
                {{ viewDate(period.item.finalDate) }}
              </template>
              <template #cell(actions)="period">
                <b-link class="btn btn-light mr-2" @click="showModalEditPeriod(period.item)">
                  <i class="fa fa-pencil text-blue" /> Editar
                </b-link> |
                <b-link class="btn btn-light mr-2" @click="deletePeriod(period.item)">
                  <i class="fa fa-trash-o text-red" /> Eliminar
                </b-link>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="edit-period" ref="modal" title="Editar periodo"  hide-footer>
      <b-form @submit="edit" ref="todoform">
        <div class="row">
          <div class="col-md-6">
            <b-form-group id="input-group-1-edit" label="Nombre:" label-for="input-1" description="Ejemplos: 1er, primero, 1">
              <b-form-input id="input-1-edit" v-model="periodToEdit.name" required placeholder="Ingrese el nombre del periodo" trim></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group id="input-group-2-edit" label="Porcentaje:" label-for="input-2" description="Ejemplo: 25">
              <b-form-input id="input-2-edit" v-model="periodToEdit.percent" required placeholder="Ingrese el porcentaje sin puntos, comas ni simbolos"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group id="input-group-3-edit" label="Orden:" label-for="input-3" description="Ejemplo: 3">
              <b-form-input id="input-3-edit" type="number" min="1" :max="periodsList.length" v-model="periodToEdit.order" required placeholder="Ingrese el porcentaje sin puntos, comas ni simbolos"></b-form-input>
            </b-form-group>
          </div>
          <!-- <div class="col-md-6">
            <b-form-group id="input-group-3-edit" label="Fecha de apertura:" label-for="input-2" description="Ejemplo: 25">
              <b-form-datepicker id="example-datepicker-start" v-model="periodToEdit.initialDate"  placeholder="Fecha inicial" class="mb-2" value-as-date></b-form-datepicker>
            </b-form-group>
          </div> -->
          <div class="col-md-6">
            <b-form-group id="input-group-4-edit" label="Activar periodo:" label-for="input-4">
              <a-switch v-model="periodToEdit.active" />
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group id="input-group-5-edit" label="Fecha de cierre:" label-for="input-5">
              <b-form-datepicker id="example-datepicker-end" v-model="periodToEdit.finalDate"  placeholder="Fecha final" class="mb-2" value-as-date></b-form-datepicker>
            </b-form-group>
          </div>
        </div>
        <b-button @click="$bvModal.hide('edit-period')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
        <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import emptyTable from '@/components/custom/cardEmptyList'
import apiClient2 from '@/services/axios/v2'
import Swal from 'sweetalert2'
import moment from 'moment'
import { showErrorMessage } from '@/services/utilities'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'ManagementPeriod',
  components: {
    emptyTable,
  },
  data() {
    return {
      form: {
        name: '',
        // initialDate: '',
        // finalDate: '',
        percent: '',
        extraPeriodEvaluation: false,
        active: false,
      },
      columns: [
        // { key: '#', label: '#' },
        { key: 'order', label: 'Orden', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'name', label: 'Nombres' },
        { key: 'percent', label: 'Porcentaje' },
        { key: 'active', label: 'Activado' },
        // { key: 'initialDate', label: 'Inicia' },
        { key: 'finalDate', label: 'Termina' },
        { key: 'extraPeriodEvaluation', label: 'Evaluación' },
        { key: 'actions', label: 'Acciones' },
      ],
      periodToEdit: {
        name: '',
        initialDate: '',
        finalDate: '',
        percent: '',
        active: false,
      },
      periodsList: [],
      yearOptions: [
        { value: null, text: 'Seleccione un año' },
      ],
      yearSelected: null,
      statusInfo: {
        subjects: 'Asignaturas ---> Pendiente',
        groups: 'Grupos ---> En proceso',
        relations: 'Relaciones ---> Pendiente',
      },
      visibleStatus: false,
      visibleStructure: false,
    }
  },
  beforeRouteEnter (to, from, next) {
    apiClient2.get('/periods').then(response => {
      next(vm => vm.setData('', response.data.data))
    }).catch(err => {
      next(vm => vm.setData(err, [])) // TODO Mostrar error
    })
  },
  watch: {
    'periodToEdit.order': function (value) {
      if (value > this.periodsList.length) {
        return this.periodsList.length
      }
    },
  },
  methods: {
    setData (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.periodsList = data
        if (data.length < 1 || data === null || !data) {
          this.visibleStructure = true
        }
      }
    },
    search() {
      apiClient2.get('/periods').then(response => {
        this.periodsList = response.data.data
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    // Guarda el periodo
    save(evt) {
      evt.preventDefault()
      const period = { ...this.form }
      apiClient2.post('/periods', period).then(response => {
        this.form.name = ''
        this.form.percent = ''
        this.form.extraPeriodEvaluation = false
        this.form.active = false
        Toast.fire({
          icon: 'success',
          title: response.data.message,
        })
        this.search()
      }).catch(err => {
        Toast.fire({
          icon: 'warning',
          title: showErrorMessage(err),
        })
      })
    },
    // Abre el modal para editar el periodo
    showModalEditPeriod(periodIn) {
      this.periodToEdit = Object.assign({}, periodIn)
      this.periodToEdit.finalDate = moment(this.periodToEdit.finalDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('YYYY-MM-DD')
      this.$bvModal.show('edit-period')
    },
    // Permite visualizar correctamente la fecha
    viewDate(period) {
      return period ? moment(period, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('YYYY-MM-DD h:mm:ss a') : 'Sin asignar'
    },
    edit(evt) { // Edita un grado llamando a la API
      evt.preventDefault()
      // TODO Validar datos
      const gotDate = new Date(this.periodToEdit.finalDate)
      this.periodToEdit.finalDate = gotDate
      this.periodToEdit.finalDate = moment(gotDate).format('YYYY-MM-DD')
      console.log(this.periodToEdit.finalDate)
      apiClient2.put(`/periods/${this.periodToEdit.id}`, this.periodToEdit).then(response => {
        this.search()
        Toast.fire({
          icon: 'success',
          title: response.data.message,
        })
        this.$bvModal.hide('edit-period')
      }).catch(err => {
        Toast.fire({
          icon: 'warning',
          title: showErrorMessage(err),
        })
      })
    },
    deletePeriod(period) {
      Swal.fire({
        title: 'Confirmar eliminación del periodo',
        text: 'Al eliminar el periodo también eliminas todas las notas asociadas al mismo.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          apiClient2.delete('/periods/' + period.id).then(response => {
            Toast.fire({
              icon: 'success',
              title: response.data.message,
            })
            this.search()
          }).catch(error => {
            Toast.fire({
              icon: 'warning',
              title: showErrorMessage(error),
            })
          })
        }
      })
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.name = ''
      this.form.percent = ''
      this.form.extraPeriodEvaluation = false
    },
  },
}
</script>
